import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { formatDate } from 'lib/formatter.ts';
import { Msg } from 'react-weui';
import PropTypes from 'prop-types';
import Http from 'services/http2';
import User from 'services/user2';
import EnumService from 'services/enum2';
import * as MobileActions from 'actions/index.ts';
import { withStyles } from '@material-ui/core/styles';

import TopNav from 'components/topNav';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Snackbar from '@material-ui/core/Snackbar';
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import green from '@material-ui/core/colors/green';

/* dev
http://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fpersonal&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/
const styles = theme => ({
  card: {
    padding: '10px',
    margin: '10px',
  },
  media: {
    height: '100px',
    borderRadius: '50%',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    overflow: 'hidden',
    width: '100px',
    display: 'inline-block',
    verticalAlign: 'bottom',
  },
  typography: {
    display: 'inline-block',
    width: '200px',
    marginLeft: '10px',
  },
  label: {
    display: 'flex',
    marginRight: 0,
    marginLeft: 0,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  variantIcon: {
    marginRight: '10px',
  },
  errorContent: {
    backgroundColor: '#f75b5b',
  },
  successContent: {
    backgroundColor: green[600],
  },
});

class Personal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inited: false,
      error: null,
      userInfo: {},
      wxLoginLimit: false,
      loginRemindFlag: false,
      showError: false,
    };
    this.errorMsg = '';
    this.errorType = 'error';
  }

  init() {
    User.init(this.companyCode).then(response => {
      if (response.success) {
        this.companyCode = User.getCompanyCode();
        this.setState({ inited: true });
        this.getUserInfo();
      } else {
        this.errorMsg = response.errorMsg;
        this.errorType = 'error';
        this.setState({ showError: true });
      }
    });
  }

  componentDidMount() {
    this.init();
  }

  getUserInfo() {
    let postbody = {
      apiPath: '/sysUser/getUserInfo',
    };
    let arrPromise = [
      Http.post('/api/user', postbody),
      EnumService.getList('B01_Sex'),
    ];
    Promise.all(arrPromise).then(arrResponse => {
      let response = arrResponse[0];
      if (response.success) {
        let data = response.data;
        let wxLoginLimit = data.wxLoginLimit === 1;
        let loginRemindFlag = data.loginRemindFlag === 1;
        EnumService.getValue('B01_Sex', data.sex).then(value => {
          data.sexName = value;
          this.forceUpdate();
        });
        this.setState({
          userInfo: data,
          wxLoginLimit: wxLoginLimit,
          loginRemindFlag: loginRemindFlag,
        });
      }
    });
  }

  handleChange = name => event => {
    const checked = event.target.checked;
    let userInfo = this.state.userInfo;
    userInfo[name] = checked ? 1 : 0;
    this.saveUserInfo(userInfo).then(response => {
      if (response) {
        this.setState({ [name]: checked });
      }
    });
  };

  async saveUserInfo(userInfo) {
    let res;
    let postbody = {
      ...userInfo,
      apiPath: '/sysUser/updateUserInfo',
    };
    await Http.post('/api/user', postbody).then(response => {
      res = response.success;
      if (response.success) {
        this.errorMsg = '个人资料保存成功';
        this.errorType = 'success';
        this.setState({ showError: true });
      } else {
        this.errorMsg = response.errorMsg;
        this.errorType = 'error';
        this.setState({ showError: true });
      }
    });
    return res;
  }

  handleClose = () => {
    this.setState({ showError: false });
  };

  render() {
    if (this.state.error !== null) {
      return <Msg {...this.state.error} />;
    }
    const { classes } = this.props;
    const { userInfo, showError } = this.state;
    return (
      <div>
        <TopNav inited={this.state.inited} />
        <Card className={classes.card}>
          {userInfo.photoUrl ? (
            <CardMedia
              className={classes.media}
              image={userInfo.photoUrl}
              title="Paella dish"
            />
          ) : (
            <AccountCircleIcon className={classes.media} />
          )}
          <Typography className={classes.typography}>
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.wxLoginLimit}
                  onChange={this.handleChange('wxLoginLimit')}
                  value="checkedA"
                  color="primary"
                />
              }
              className={classes.label}
              labelPlacement="start"
              label="仅限微信登录"
            />

            <FormControlLabel
              control={
                <Switch
                  checked={this.state.loginRemindFlag}
                  onChange={this.handleChange('loginRemindFlag')}
                  value="checkedB"
                  color="primary"
                />
              }
              className={classes.label}
              labelPlacement="start"
              label="登录提醒 (微信)"
            />
          </Typography>
          <div className="order-detail-block">
            <ul>
              <li>
                <label className="order-detail-label">用户姓名</label>
                <div className="order-detail-value">{userInfo.nickName}</div>
              </li>
              <li>
                <label className="order-detail-label">常用邮箱</label>
                <div className="order-detail-value">{userInfo.email}</div>
              </li>
              <li>
                <label className="order-detail-label">性别</label>
                <div className="order-detail-value">{userInfo.sexName}</div>
              </li>
              <li>
                <label className="order-detail-label">绑定微信</label>
                <div className="order-detail-value">{userInfo.wxNick}</div>
              </li>
              <li>
                <label className="order-detail-label">携客号</label>
                <div className="order-detail-value">{userInfo.loginName}</div>
              </li>
              <li>
                <label className="order-detail-label">绑定手机</label>
                <div className="order-detail-value">{userInfo.mobile}</div>
              </li>
              <li>
                <label className="order-detail-label">生日</label>
                <div className="order-detail-value">
                  {formatDate(userInfo.birthday, 'YYYY-MM-DD')}
                </div>
              </li>
              <li>
                <label className="order-detail-label">QQ</label>
                <div className="order-detail-value">{userInfo.qqNum}</div>
              </li>
            </ul>
          </div>
        </Card>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={showError}
          onClose={this.handleClose}
          autoHideDuration={2000}
        >
          <SnackbarContent
            className={
              this.errorType === 'error'
                ? classes.errorContent
                : classes.successContent
            }
            aria-describedby="client-snackbar"
            message={
              <span className={classes.message}>
                {this.errorType === 'error' ? (
                  <ErrorIcon className={classes.variantIcon} />
                ) : (
                  <CheckCircleIcon className={classes.variantIcon} />
                )}
                {this.errorMsg}
              </span>
            }
          />
        </Snackbar>
      </div>
    );
  }
}

Personal.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.login,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Personal));
